<template>
  <div class="real-search">
    <el-select v-model="value" style="width:100%" filterable @change="selectUser" remote :placeholder="holdermsg" :remote-method="getUser" :loading="loading">
      <el-option v-for="item in options" :key="item.value" :label="item.username" :value="item.username">
        <span style="float: left">{{ item.username }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
      </el-option>
    </el-select>
  </div>
</template>
<script>
import usermember from '../../data/basic/plan/usermember.js'
export default {
  data() {
    return {
      value: '',
      options: [],
      holdermsg: '请输入关键词',
      loading: false
    }
  },
  props: ['data', 'placeholder'],
  created() {
    if (this.data) {
      this.value = this.data.num
    }
    if (this.placeholder) {
      this.holdermsg = this.placeholder
    }
  },
  watch: {
    data() {
      this.value = this.data.num
    }
  },
  methods: {
    // 用户查询
    getUser(params) {
      let get_user = async() => {
        let state = await usermember.search({ keyword: params })
        if (state) {
          this.loading = false
          this.options = state.content
        }
      }
      if (params !== '') {
        this.loading = true;
        get_user()
      } else {
        this.options = [];
      }
    },
    // 监听选中事件
    selectUser(data) {
      this.$emit('change', data)
    }
  }
}

</script>
<style lang="stylus" scoped>
.real-search {
  width: 100%;
  height: auto;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// RealSearch.vue?2f259f52